import type { TypographyStyle } from '@/components/canvas/document/publicTypes';

export interface TextDocument {
  version: 1;
  blocks: TextBlock[];
}

export type TextBlockType =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'paragraph'
  | 'ordered-list-item'
  | 'unordered-list-item';

export interface TextBlock {
  id: string;
  type: TextBlockType;
  runs: TextRun[];
}

export interface TextRun {
  id: string;
  text: string;
  style?: InlineTextStyle;
}

export interface ListStyle {
  markerGap: number;
  indent: number;
  unorderedMarker: 'disc' | 'circle' | 'square';
}

export interface InlineTextStyle extends Partial<TypographyStyle> {
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  strike?: boolean;
  superscript?: boolean;
  subscript?: boolean;
  link?: {
    href: string;
    target?: '_blank' | '_self';
  };
  backgroundColor?: string;
}

export interface TextSelectionPosition {
  blockId: string;
  runId: string;
  offset: number;
}

export interface TextSelection {
  anchor: TextSelectionPosition;
  focus: TextSelectionPosition;
}

export const TEXT_DOCUMENT_VERSION = 1 as const;

export function createTextId(prefix = 'txt'): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}
